import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import { useContext, useEffect } from "react"

// views
import About from "./views/games/about/About"
import ConsignaView from "./views/Consigna"
import QAView from "./views/QA"
import Home from "./views/Home"
import Login from "./views/Login"
import Admin from "./views/admin/Admin"
import NotFound from "./views/NotFound"

// sesion
import { getCookie } from "./helpers/cookies"
import { UserContext } from "./store/store"

// lang
import { useTranslation } from "react-i18next"

import "./App.scss"
import "./App-light.scss"

import CrosswordView from "./views/games/CrosswordView"
import GuessWordView from "./views/games/GuessWordView"
import WordsearchView from "./views/games/WordsearchView"
import MemoryView from "./views/games/MemoryView"
import LPracticeView from "./views/games/GrammarView"
import SeaAnimalsViewOnline from "./views/games/SeaAnimalsViewOnline"
import SeaAnimalsViewOffline from "./views/games/SeaAnimalsViewOffline.js"
import StoryView from "./views/games/StoryView"
import { config } from "./config"
import Watchdog from "./views/Watchdog"
import RespuestaView from "./views/Respuesta"
import Container from "./components/ui/Container"
import Sugerencias from "./views/Sugerencias"
import Tutti from "./views/games/tutti/TuttiView"

const App = () => {
  const [state, dispatch] = useContext(UserContext)

  const { i18n } = useTranslation()

  useEffect(() => {
    const abortCtrl = new AbortController()

    let jwtCokie = getCookie("jwt"),
      nameCookie = getCookie("username"),
      themeCookie = getCookie("theme"),
      langCookie = getCookie("i18n")

    if (jwtCokie)
      dispatch({
        type: "SET_LOGIN",
        payload: {
          jwt: jwtCokie,
          usr: {
            name: nameCookie, // <- que lo saque del token
          },
        },
      })

    if (themeCookie)
      dispatch({
        type: "SET_THEME",
        payload: {
          theme: themeCookie,
        },
      })

    if (langCookie) i18n.changeLanguage(langCookie)

    // cleanup func
    return () => abortCtrl.abort()
  }, [dispatch, i18n])

  useEffect(() => {
    switch (state.theme) {
      case "light":
        document.body.classList.add("light-theme")
        break
      default:
        document.body.classList.remove("light-theme")
        break
    }
  }, [state])

  if (config.PRIVATE_MODE) if (!getCookie("unlocked")) return <Watchdog />

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>

        <Route exact path="/sugerencias">
          <Sugerencias />
        </Route>

        <Route exact path="/acerca">
          <About />
        </Route>

        <Route exact path="/login">
          <Login />
        </Route>

        <Route exact path="/admin">
          <Admin />
        </Route>

        <Route exact path={["/qa/:id"]}>
          <QAView />
        </Route>

        {/* juegos */}
        <Route exact path={["/crossword", "/crossword/:uid"]}>
          <CrosswordView />
        </Route>

        <Route exact path={["/wordsearch", "/wordsearch/:uid"]}>
          <WordsearchView />
        </Route>

        <Route exact path="/language-practice">
          <LPracticeView />
        </Route>

        <Route exact path={["/story", "/story/:uid"]}>
          <StoryView />
        </Route>

        <Route exact path="/memory">
          <MemoryView />
        </Route>

        <Route exact path="/sea-animals">
          <SeaAnimalsViewOnline />
        </Route>

        <Route exact path="/guessword">
          <GuessWordView />
        </Route>

        <Route exact path="/seaanimals-offline">
          <SeaAnimalsViewOffline />
        </Route>

        <Route exact path={["/consigna", "/consigna/:id"]}>
          <ConsignaView />
        </Route>

        <Route exact path={["/consigna/:id"]}>
          <ConsignaView />
        </Route>

        <Route exact path={["/consigna/:con_id/respuestas/:res_id"]}>
          <RespuestaView />
        </Route>

        <Route exact path="/tutti">
          <Tutti />
        </Route>

        <Route path="*">
          <Container>
            <NotFound />
          </Container>
        </Route>
      </Switch>
    </Router>
  )
}

export default App
